import axios from 'axios';
import {
  authHeaders,
  deleteAuthenticated,
  getAuthenticated,
  patchAuthenticated,
} from './http';

const fallbackExportFilename = () =>
  `the-tavern-data-export-${new Date().toISOString().slice(0, 10)}.json`;

const filenameFromDisposition = (disposition) => {
  const match = /filename="?([^";]+)"?/i.exec(disposition || '');

  return match?.[1] || fallbackExportFilename();
};

export const downloadMyData = async () => {
  const response = await axios.get('/api/account/export', {
    headers: authHeaders(),
    responseType: 'blob',
  });
  const filename = filenameFromDisposition(response.headers?.['content-disposition']);
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);

  return { filename };
};

export const deleteMyAccount = async () => deleteAuthenticated('/api/account');

export const fetchEmailPreferences = async () =>
  getAuthenticated('/api/account/email-preferences');

export const updateEmailPreferences = async (preferences) =>
  patchAuthenticated('/api/account/email-preferences', preferences);

export const fetchPushPreferences = async () =>
  getAuthenticated('/api/account/push-preferences');

export const updatePushPreferences = async (preferences) =>
  patchAuthenticated('/api/account/push-preferences', preferences);
